import { marketingHead } from "@/lib/marketing/seo";
import { breadcrumbs, webPageOf } from "@/lib/marketing/ppl-schema";

export function quickSignupHead() {
  const seo = {
    title: "Sign up free | PEOPLE AI Workforce",
    description:
      "Start PEOPLE Core free for your community: name, email and password, a code to confirm, and you are inside. No card. Add AI employees whenever you are ready.",
    path: "/v2/signup",
    imageAlt: "PEOPLE AI Workforce. The AI workforce for senior living",
  };
  return marketingHead({
    ...seo,
    schema: [webPageOf(seo), breadcrumbs({ name: "Sign up", path: "/signup" })],
  });
}
